module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "height": "0pt"
    },
    attrs: {
      "id": "_idContainer003"
    }
  }), _c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "structure-next",
    attrs: {
      "id": "calibre_pb_11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_vm._v("“Step well the path of remembering lit by the stars you have placed, with intention, in the canopy of your own n"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ight")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("sky.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quoteauthor"
  }, [_vm._v("—Mary Anne"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("Radmacher")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_vm._v("“A goal is a thing you decide to do. It has a measured result and an ending. An intention is an established motivation that guides you to your goal. It is boundless and only ends whe"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("n you")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quoteauthor"
  }, [_vm._v("—Mary Anne"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("Radmacher")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_12"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a3e6283","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/LiveWithIntention_split_004.vue
// module id = 72
// module chunks = 0